import React from 'react';
import * as S from './styles';

const Modal = ({ children, width, alignButtons, gap }: any) => (
  <S.Modal width={width} alignButtons={alignButtons} gap={gap}>
    <div className="container">{children}</div>
  </S.Modal>
);

export default Modal;
